
import {Component, Vue, Watch, Ref} from "vue-property-decorator";
import { Socket } from "vue-socket.io-extended";
import app from "@/main";
import { ProgramPaths } from "@/enum/ProgramPaths";
import MenuBar from "@/components/page-components/MenuBar.vue";
import BildirimInfo from "@/components/infos/BildirimInfo.vue";
import UrunlerInfo from "@/components/infos/UrunlerInfo.vue";
import ImzaUyapConnectionInfo from "@/components/infos/ImzaUyapConnectionInfo.vue";
import UserInfoCard from "@/components/UserInfoCard.vue";
import AppFooter from "@/layout/AppFooter.vue";
import ChatbotDialog from "@/components/dialogs/ChatbotDialog.vue";
import GuncellemelerInfo from "@/components/infos/GuncellemelerInfo.vue";
import SpinnerToast from "@/components/SpinnerToast.vue";
// import RatingDialog from "@/components/dialogs/RatingDialog.vue";
import _swal from "sweetalert2";
import {KullaniciBilgileriCevap} from "@/plugins/uyap-plugin/uyap/KullaniciBilgileri";

declare global {
  interface Window {
    pekiSettings: any;
  }
}

@Component({
  computed: {
    ProgramPaths() {
      return ProgramPaths;
    },
  },
  components: {
    ChatbotDialog,
    AppFooter,
    UserInfoCard,
    ImzaUyapConnectionInfo,
    UrunlerInfo,
    BildirimInfo,
    MenuBar,
    GuncellemelerInfo,

    SpinnerToast,
    // RatingDialog,
  }
})
export default class App extends Vue {
  drawer = null as boolean | null; // null olarak başlat
  isAnaMenu = false;
  ProgramPaths = ProgramPaths;
  chatBotDialog: boolean = false;
  // showRatingDialog: boolean = false;

  @Ref("spinnerToast") readonly spinnerToast!: SpinnerToast;

  created() {
    this.drawer = true;
    this.$store.commit('initAutoPlay');
  }

  mounted() {
    // Spinner service'e component referansını ver
    this.$nextTick(() => {
      if (this.$spinner && this.spinnerToast) {
        (this.$spinner as any).setComponent(this.spinnerToast);
      }
      // this.checkAndShowRating();
    });
  }

  get isEicrapro() {
    return this.$route.path.includes(ProgramPaths.eicrapro);
  }

  // get ratingMode() {
  //   return this.isEicrapro ? 'beta-screen' : 'general';
  // }

  // get pendingTakipHazirlaRatingDialog(): boolean {
  //   return this.$store.getters['takipHazirla/pendingTakipHazirlaRatingDialog'];
  // }

  // checkAndShowRating() {
  //   if (this.isEicrapro) {
  //     return;
  //   }
  //   if (this.$store.state.user.rating_visible && this.userId) {
  //     this.showRatingDialog = true;
  //   }
  // }
  get chatBotButton() {
    const path = this.$route.path;
    const visiblePaths = [
      ProgramPaths.icrapro + "/takip-ekle/" + this.$route.params.id,
      ProgramPaths.icrapro + "/takip/" + this.$route.params.id,
    ];

    return !visiblePaths.includes(path);
  }

  // Toggle metodu ekle
  toggleDrawer() {
    this.drawer = !this.drawer;
  }

  // MenuBar'dan gelen close-drawer event'ini handle et
  closeDrawer() {
    if (this.$vuetify.breakpoint.smAndDown) {
      this.drawer = false;
    }
  }

  // Route'a göre drawer durumunu ayarlayan method
  setDrawerStateByRoute() {
    const isMainRoute =
        this.$route.path === ProgramPaths.ofispro ||
        this.$route.path === ProgramPaths.icrapro ||
        this.$route.path === ProgramPaths.eicrapro;

    if (isMainRoute) {
      this.drawer = true;
    }
  }

  get userId() {
    let id = this.$store.state.user.id;
    return id;
  }

  get showDevWarn() {
    let isEicrapro = this.$route.path.includes(ProgramPaths.eicrapro);
    let isTestSite =
        location.hostname.split(".")[0] == "cloudtest" ||
        location.hostname.split(".")[0] == "cloudbeta" ||
        location.hostname.split(".")[0] == "localhost";
    return isEicrapro && isTestSite && this.$store.getters.isEicraproDevMode;
  }

  toggleDevMode(): void {
    const nextState = !this.$store.state.eicraproDevMode;
    this.$store.commit("setEicraproDevMode", nextState);
    this.$store.dispatch("checkUyapSession");
  }

  @Socket("player")
  onPlayer(player: any) {
    this.$store.commit("setPlayerDurum", Number(player));
  }

  @Socket("updateTasks")
  onUpdateTask() {
    this.$store.dispatch("updateTasks");
  }

  @Socket("imzaMessage")
  async onImzaMessage(message: any) {
    console.log("imzaMessage Fired", message);
    await _swal.fire(message);
  }

  @Socket("uyapAvukatBilgileri")
  onAvukatBilgileriChange(data: {uyapAvukatBilgileri: KullaniciBilgileriCevap, uyapAvukatBakiye: string, uyapSorguBakiye: string}) {
    this.$store.commit("setUyapAvukatBilgileri", data.uyapAvukatBilgileri);
    this.$store.commit("setUyapAvukatBakiye", data.uyapAvukatBakiye);
    this.$store.commit("setUyapSorguBakiye", data.uyapSorguBakiye);
  }

  @Socket("refreshConnection")
  onRefreshConnection() {
    console.log("Socket refreshConnection triggered");
    this.$store.dispatch("checkUyapSession");
  }

  @Socket("notification")
  onNotification(notification: { message: string, seconds: number }) {
    this.$spinner.message(notification.message,notification.seconds);
  }

  @Socket("uyapconnection")
  async onUyapConnection(data: { connected: boolean; JSESSIONID: string }) {
    console.log("soket cevap uyap bağlı", data.connected ? "EVET" : "HAYIR");
    if (data) {
      this.$store.commit("setUyapConnection", data.connected);
      if (
          !(
              window.localStorage.hasOwnProperty("JSESSIONID") &&
              window.localStorage.getItem("JSESSIONID") == data.JSESSIONID
          )
      ) {
        localStorage.setItem("JSESSIONID", data.JSESSIONID);
        // TODO: port değişken yapılacak
        const cookieSetUrl =
            "https://imza.eicrapro.com:6099" +
            "/cookie?" +
            data.JSESSIONID +
            ";SameSite=None;Secure";
        await app.$uyap.SetCookie().run({ url: cookieSetUrl });
      }
    }
  }

  @Watch("$route")
  onPathnameChange() {
    if (
        this.$route.path == ProgramPaths.ofispro ||
        this.$route.path == ProgramPaths.icrapro ||
        this.$route.path == ProgramPaths.eicrapro
    ) {
      this.isAnaMenu = true;
      this.drawer = true; // Ana menüde drawer'ı aç
    } else {
      this.isAnaMenu = false;
      // Mobilde route değiştiğinde drawer'ı kapat
      if (this.$vuetify.breakpoint.smAndDown) {
        this.drawer = false;
      }
    }

    // Anket kontrolü (Route değiştiğinde de kontrol et)
    // this.checkAndShowRating();
  }

  @Watch("$socket.connected")
  onSocketConnectionChange() {
    console.log("Socket connected WATCH");
    this.$nextTick(() => {
      this.$store.dispatch("checkUyapSession");
    });
  }

  // @Watch("pendingTakipHazirlaRatingDialog")
  // onPendingTakipHazirlaRatingChange(pending: boolean) {
  //   if (pending && this.isEicrapro && this.userId && this.$store.state.user.rating_visible) {
  //     this.showRatingDialog = true;
  //   }
  // }

  // @Watch("showRatingDialog")
  // onShowRatingDialogChange(val: boolean) {
  //   if (!val) {
  //     this.$store.commit('takipHazirla/CLEAR_PENDING_TAKIP_HAZIRLA_RATING');
  //   }
  // }

  // onRatingSave(data: { rating: number, comment: string }) {
  //   console.log('User Rating:', data);
  //   this.$toast.success('Görüşleriniz için teşekkür ederiz!');
  // }
}
